const initSearch = () => {
    Alpine.data('search', () => ({
        isLoading: false,
        noResults: false,
        searchQuery: '',
        searchResults: [],
        init() {
            const urlQuery = new URLSearchParams(window.location.search)
            if (urlQuery.has('souradnice')) {
                this.searchQuery = localStorage.getItem(urlQuery.get('souradnice'))
            }

            window.addEventListener("handleLocationSuggestions", (e: CustomEvent) => {
                this.searchResults = e.detail?.suggestions ?? []
                this.noResults = !this.searchResults.length
                this.isLoading = false
            })

            window.addEventListener("setLocationSearchQuery", (e: CustomEvent) => {
                this.clearResults(e.detail?.locality ?? '')
            })

            Livewire.on('change-map', (params: { type: string }) => {
                params.type !== 'lokality' && this.clearResults()
            })
        },
        getSearchOptions() {
            if (this.searchQuery === '') {
                this.clearResults()
                return
            }

            if (this.searchQuery.length < 2) return

            this.isLoading = true
            window.dispatchEvent(new CustomEvent("getLocationSuggestions", { detail: { search: this.searchQuery }}));
        },
        clearResults(query = '') {
            this.searchQuery = query
            this.searchResults = []
            this.noResults = false
        },
        selectTerm(index: number) {
            const placePrediction = this.searchResults[index];
            window.dispatchEvent(new CustomEvent("selectLocationSuggestions", { detail: { placePrediction: index }}));
            this.clearResults(placePrediction);
        },
        formatLabel(label: string) {
            const regexp = new RegExp(`${this.searchQuery}`, 'i')
            return label?.replace(regexp, '<b>$&</b>') ?? ''
        }
    }))
}

export default initSearch
